const ROW_DEFINITIONS = Object.freeze([
  ['parcels-fee', '運費', '+', ctx => ctx.parcelsFee, ctx => ctx.base.feeInfo.finalParcelsFeeFormulas],
  ['busy-season-fee', '繁盛期附加費', '+', ctx => ctx.jyoBusyFee],
  ['overload-fee', '超重附加費', '+', ctx => ctx.jyoOvldFee],
  ['hct-volume-fee', '新竹物流材積費', '+', ctx => ctx.jyHctCaiFee],
  ['hct-pallet-fee', '新竹物流棧板費', '+', ctx => ctx.hctPalletFee],
  ['warehouse-fs-fee', '加固費', '+', ctx => ctx.isFsFee],
  ['warehouse-ctn-fee', '紙箱費', '+', ctx => ctx.isCtnFee],
  ['warehouse-ws-fee', '木架費', '+', ctx => ctx.isWsFee],
  ['warehouse-wb-fee', '木箱費', '+', ctx => ctx.isWbFee],
  ['warehouse-wx-fee', '木架加固費', '+', ctx => ctx.isWxFee],
  ['warehouse-fcc-fee', '防潮包裝費', '+', ctx => ctx.isFccFee],
  ['warehouse-owsu-fee', '其他倉儲服務費', '+', ctx => ctx.isOwsuFee],
  ['apart-fee', '分箱費', '+', ctx => ctx.jyoApartFee],
  ['remote-home-fee', '偏遠地區派送費', '+', ctx => ctx.hmdeFee],
  ['pre-tax-deposit', '稅金保證金', '+', ctx => ctx.base.otherFees.preTax],
  ['island-fee', '離島費', '+', ctx => ctx.base.otherFees.landFee],
  ['island-discount', '離島費優惠', '-', ctx => ctx.base.otherFees.landFeeDiscount],
  ['sea-delivery-fee', '海快派送費', '+', ctx => ctx.sedeFee],
  ['local-delivery-fee', '派送費', '+', ctx => ctx.localFee],
  ['van-fee', '專車派件費', '+', ctx => ctx.vanFee],
  ['loss-insurance-fee', '遺失保價費', '+', ctx => ctx.premiumFee],
  ['damage-insurance-fee', '運損保價', '+', ctx => ctx.displayFees.damageInsurancePremium],
  [
    'overtime-insurance-fee',
    '超時保障費',
    '+',
    ctx => ctx.timeInsFee,
    null,
    ctx => ctx.isTimeIns,
  ],
  [
    'tax-fee',
    '稅金',
    '+',
    ctx => ctx.finalSrParcelsFeeFormulas?.taxType && !ctx.isAllIncTax
      ? ctx.finalSrParcelsFeeFormulas.taxFee?.[4]
      : 0,
    ctx => ctx.finalSrParcelsFeeFormulas?.taxFee,
  ],
  ['coupon-discount', '優惠券', '-', ctx => ctx.currCoupon?.discountInfo?.discount],
  [
    'temporary-discount',
    '限時優惠',
    '-',
    ctx => ctx.finalSrParcelsFeeFormulas?.tempDiscountFees?.[4],
    ctx => ctx.finalSrParcelsFeeFormulas?.tempDiscountFees,
  ],
  [
    'address-discount',
    '地址優惠',
    '-',
    ctx => ctx.cneeAddressDiscount?.[4],
    ctx => ctx.cneeAddressDiscount,
  ],
])

function normalizeAmount (amount) {
  const value = Number(amount || 0)
  return Number.isFinite(value) ? value : 0
}

export function buildFeeRows (summary, displayFees = {}) {
  const ctx = {
    ...summary.amountContext,
    base: summary.base,
    displayFees,
  }
  const rows = ROW_DEFINITIONS.map(([id, label, sign, getAmount, getFormula, getVisible]) => {
    const amount = normalizeAmount(getAmount(ctx))
    return {
      id,
      label,
      sign,
      amount,
      formula: getFormula ? getFormula(ctx) || null : null,
      visible: amount > 0 && (getVisible ? getVisible(ctx) : true),
    }
  })
  rows.push({
    id: 'total',
    label: '合計',
    sign: '=',
    amount: normalizeAmount(summary.sharedAmount),
    formula: null,
    visible: true,
  })
  return rows
}

export default buildFeeRows
